import { useTheme } from "../styles";
export var IdenticonsCustomProperty;
(function (IdenticonsCustomProperty) {
    IdenticonsCustomProperty["light"] = "--identicons-color-light";
    IdenticonsCustomProperty["base"] = "--identicons-color-base";
    IdenticonsCustomProperty["dark"] = "--identicons-color-dark";
})(IdenticonsCustomProperty || (IdenticonsCustomProperty = {}));
export var getIdenticonsColorMap = function (theme, color) {
    if (color === void 0) { color = "default"; }
    /*
    These are hardcoded since Identicons does not use palette colors. It was decided by design to keep this divergence for now.
    See: https://auth0team.atlassian.net/browse/DXDP-2354
    */
    if (color === "primary") {
        return {
            light: "#D0CEFF",
            base: "#A5A0FF",
            dark: "#635DFF",
        };
    }
    return {
        light: "#C4C4C4",
        base: "#9B9D9F",
        dark: "#65676E",
    };
};
export var getIdenticonsVariableOverrides = function (theme, color) {
    var _a;
    if (color === void 0) { color = "default"; }
    var map = getIdenticonsColorMap(theme, color);
    return _a = {},
        _a[IdenticonsCustomProperty.light] = map.light,
        _a[IdenticonsCustomProperty.base] = map.base,
        _a[IdenticonsCustomProperty.dark] = map.dark,
        _a;
};
export var useColorMap = function (_a) {
    var color = _a.color;
    var theme = useTheme();
    return getIdenticonsColorMap(theme, color);
};
